import { useCallback } from 'react';

import { useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { useHistory } from 'react-router-dom';

import { SNACKBAR_SKIN } from 'components/shared/Snackbar';
import { getPath, PAGE_DETAILS_PATH } from 'constants/routes';
import {
  DUPLICATE_ERROR_MESSAGE,
  EDITING_PERMISSION_BLOCK,
  EDITING_PERMISSION_TEXT,
  GENERAL_ERROR_MESSAGE,
} from 'constants/texts';
import { showSnackbar } from 'hooks/useSnackbar';
import { accountIdSelector } from 'store/user/selectors';

export function useSaveErrorHandler({ needToRedirect = false } = {}) {
  const accountId = useSelector(accountIdSelector);
  const history = useHistory();
  const { libType, pageId } = useParams();

  const handleLinkClick = useCallback(() => {
    history.push(getPath(PAGE_DETAILS_PATH, { pageId, accountId, libType }));
  }, [accountId, history, libType, pageId]);

  return useCallback(
    (err) => {
      const config = {
        text: GENERAL_ERROR_MESSAGE,
        type: SNACKBAR_SKIN.ERROR,
      };

      if (err?.errors?.status === 422 && err?.errors?.source?.masterPropertyId) {
        const text = 'You cannot save this page because the master property page was deleted.';
        config.text = (
          <>
            {text}
            {needToRedirect && (
              <>
                {' '}
                Please attach it to a new master page{' '}
                <div
                  style={{
                    fontWeight: 'bold',
                    textDecoration: 'underline',
                    display: 'inline',
                    cursor: 'pointer',
                  }}
                  onClick={handleLinkClick}
                >
                  here.
                </div>
              </>
            )}
          </>
        );
      }

      if (err?.errors?.status === 403 && err?.errors?.title?.includes(EDITING_PERMISSION_TEXT)) {
        config.text = EDITING_PERMISSION_BLOCK;
      }

      if (
        err?.errors?.status === 422 &&
        [
          'This handle already exists. Please modify tags to continue.',
          'The content already exists with this Name and Labels. Please modify to continue.',
        ].includes(err?.errors?.source?.handle?.[0])
      ) {
        config.text = DUPLICATE_ERROR_MESSAGE;
      }
      showSnackbar(config);
    },
    [handleLinkClick, needToRedirect],
  );
}
